import { useAtom, useAtomValue } from "jotai";
import { ChangeEvent, FormEvent } from "react";

import { isVinValidAtom } from "atoms/vin/validation";
import { vinAtom, vinErrorAtom } from "atoms/vin/vin";
import { useClientTranslation } from "hooks/useClientTranslation";

import { vinValidator } from "../VinValidator";

export const useVinForm = () => {
  const { t } = useClientTranslation();
  const [vin, setVin] = useAtom(vinAtom);
  const { vinHasPhoto, vinHasValue } = useAtomValue(isVinValidAtom);
  const isValid = !!vinHasPhoto || vinHasValue?.isValid;
  const [error, setError] = useAtom(vinErrorAtom);
  const handleSubmit = (onSubmit: (data: any) => void) => (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    onSubmit(vin);
  };

  const onType = ({ currentTarget }: ChangeEvent<HTMLInputElement>) => {
    setVin(currentTarget.value);
    const validVin = vinValidator(currentTarget.value);
    const hasError = !validVin.isValid;
    const errorMessage = validVin.hasInvalidCharacters
      ? t("vin.input_error_invalid_character")
      : t("vin.input_error_invalid");

    hasError ? setError(errorMessage) : setError("");
  };

  return {
    onType,
    handleSubmit,
    isValid,
    error,
    vin,
  };
};
